const CryptoCurrencies = () => {
  return (
    <div>
      <h1>I'm the crypto page</h1>
    </div>
  );
};
export default CryptoCurrencies;
